module.exports = __webpack_public_path__ + "img/imaging.3a7bcf54.svg";